import { Action } from "redux";
import { OrganizationKeyName } from "../../../model/Organization";

export const DENY_USER_FAIL = "DENY_USER_FAIL";

export interface DenyUserFailAction extends Action {
  type: typeof DENY_USER_FAIL;
  organization: OrganizationKeyName;
  userId: string | number;
}

export const denyUserFailAction = (
  organization: OrganizationKeyName,
  userId: string | number
): DenyUserFailAction => ({
  type: DENY_USER_FAIL,
  organization,
  userId,
});
